(() => {
  if (customElements.get('featured-products-carousel')) {
    return;
  }

  class FeaturedProductsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        navigation: {
          prevEl: this.closest(
            '[featured-products-carousel="wrapper"]',
          ).querySelector('.slider__arrow.arrow-left'),
          nextEl: this.closest(
            '[featured-products-carousel="wrapper"]',
          ).querySelector('.slider__arrow.arrow-right'),
        },
        slidesPerView: 'auto',
        spaceBetween: 12,
        breakpoints: {
          750: {
            spaceBetween: 20,
          },
        },
      };
      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('featured-products-carousel', FeaturedProductsCarousel);
})();
